import {
  LoginPageUserBrandingSettings
} from '../../../../projects/app-login-code/src/domain/user-branding';
import {BackofficeUserBrandingSettings} from './user-branding';

export class UserBrandingSetting {
  public get isDefault(): boolean {
    return this.domainNameAsUid === 'default';
  }
  constructor(
    public domainNameAsUid: string,
    public login: LoginPageUserBrandingSettings,
    public backoffice: BackofficeUserBrandingSettings
  ) {
  }

  public static fromRawResponse(rawResponse: any): UserBrandingSetting {
    const parsedUserBrandingSetting = JSON.parse(rawResponse.SettingsJson);
    return new UserBrandingSetting(rawResponse.DomainNameAsUid, LoginPageUserBrandingSettings.FromRawObject(parsedUserBrandingSetting.login), BackofficeUserBrandingSettings.FromRawObject(parsedUserBrandingSetting.backoffice));
  }
}
